export default __webpack_public_path__ + "static/video-banner-3de24a20be3e4789a48e14f132e0662a.png";